import { LocalStorageKey as e, getBaseUrl as t } from "@magnopus/env";
//#region src/lib/services/local-storage/local-storage.service.ts
var n = (e) => {
	let n = t();
	fetch(`${n}/cdn-session`, {
		method: "GET",
		credentials: "include",
		headers: { Authorization: `Bearer ${e}` }
	}).catch((e) => console.error("Could not set cookie. Origin may not be allowed.", e));
}, r = (t) => {
	localStorage.setItem(e.OLY_AUTH, JSON.stringify(t));
}, i = () => {
	let t = localStorage.getItem(e.OLY_AUTH) ?? void 0, n = t ? JSON.parse(t) : void 0;
	switch (typeof n) {
		case "object": break;
		default: return;
	}
	let r = typeof n.token == "string" && n.token, i = typeof n.expire == "string" && n.expire, a = typeof n.userId == "string" && n.userId;
	if (!(!r || !i || !a)) return {
		token: r,
		expire: i,
		userId: a
	};
}, a = () => {
	localStorage.removeItem(e.OLY_AUTH);
}, o = (t) => {
	localStorage.setItem(e.OLY_NEWSLETTER, JSON.stringify(t));
}, s = () => {
	let t = localStorage.getItem(e.OLY_NEWSLETTER) ?? void 0, n = t ? JSON.parse(t) : void 0;
	switch (typeof n) {
		case "boolean": break;
		default: return;
	}
	return n;
}, c = () => {
	localStorage.removeItem(e.OLY_NEWSLETTER);
}, l = (t) => {
	localStorage.setItem(e.SKETCHFAB_AUTH, JSON.stringify(t));
}, u = () => {
	let t = localStorage.getItem(e.SKETCHFAB_AUTH) ?? void 0, n = t ? JSON.parse(t) : void 0;
	switch (typeof n) {
		case "object": break;
		default: return;
	}
	return n;
}, d = {
	setOlyAuth: r,
	getOlyAuth: i,
	removeOlyAuth: a,
	setOlyNewsLetter: o,
	getOlyNewsLetter: s,
	removeOlyNewsLetter: c,
	setSketchfabAuth: (e) => {
		let t;
		t = u(), t ||= [];
		let n = t.findIndex((t) => t.userId === e.userId);
		n >= 0 ? t[n] = e : t.push(e), l(t);
	},
	getSketchfabAuth: (e) => {
		let t = u(), n;
		if (t && t.length && (n = t.find((t) => t.userId === e)), !n) return;
		let r = typeof n.token == "string" && n.token, i = typeof n.expire == "string" && n.expire, a = typeof n.userId == "string" && n.userId;
		if (!(!r || !i || !a)) return {
			token: r,
			expire: i,
			userId: a
		};
	},
	removeSketchfabAuthArray: () => {
		localStorage.removeItem(e.SKETCHFAB_AUTH);
	},
	setAssetCookie: n
};
//#endregion
export { d as localStorageService };
